import { AppConfigOverride } from '@abstractTypes/envs'
import { ProductTypeValues } from '@abstractTypes/filter'
import { FaPlaylistType } from '@abstractTypes/frameAdvisor'

const getGoEnvVariables = () => {
  const goEnvVariables: AppConfigOverride = {
    shopperSlug: 'go',
    shopperName: 'Grand Optical',
    storeID: '14',
    storeLang: 'pt-PT',
    default: {
      productType: ProductTypeValues.SUN,
      faPlaylistType: FaPlaylistType.SUN,
    },
    vmStore: 'go',
    vmStyle: 'go',
  }

  return goEnvVariables
}

export default getGoEnvVariables
